/**
 * Canonical registry of keyboard shortcuts genuinely implemented across racler.dev.
 *
 * Source of truth references:
 * - Cmd/Ctrl+S: EditorArea (Monaco saveRef command)
 * - Shift+Option/Alt+F: EditorArea (Monaco formatRef action)
 * - Cmd/Ctrl+F: EditorArea (Monaco built-in find widget)
 * - Cmd/Ctrl+Shift+F: IdeLayout + isProjectSearchShortcut (ProjectSearch modal)
 * - Cmd/Ctrl+B: IdeLayout (toggle files/explorer panel)
 * - Cmd/Ctrl+J: IdeLayout (toggle tools/bottom panel)
 * - Enter / Cmd+Enter: Composer (isSendKey submit)
 * - Shift+Enter: Composer (multiline textarea input)
 */
export interface ShortcutDefinition {
  key: string;
  description: string;
}

export const IMPLEMENTED_SHORTCUTS: readonly ShortcutDefinition[] = [
  { key: "Cmd/Ctrl+S", description: "Save the active file" },
  { key: "Shift+Option/Alt+F", description: "Format document" },
  { key: "Cmd/Ctrl+F", description: "Find in active file" },
  { key: "Cmd/Ctrl+Shift+F", description: "Search across project files" },
  { key: "Cmd/Ctrl+B", description: "Show or hide the Explorer" },
  { key: "Cmd/Ctrl+J", description: "Show or hide the Tools panel" },
  { key: "Enter / Cmd+Enter", description: "Send chat message" },
  { key: "Shift+Enter", description: "New line in chat message" },
] as const;
